/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var Emitter           = require('cjs-emitter'),
    app               = require('mag-app'),
    api               = require('./api'),
    player            = require('./player'),
    setTitle          = require('./title'),
    spinner           = require('../ui/spinner'),
    targets           = {
        video: {
            current: 0,
            stack: [],
            lastWatch: 0,
            startCode: 202,
            playbackCode: 203,
            skipPlaybackTimes: 0,
            skipAppStartTimes: 0
        },
        'tv-channel': {
            current: 0,
            stack: [],
            lastWatch: 0,
            startCode: 204,
            playbackCode: 205,
            skipPlaybackTimes: 0,
            skipAppStartTimes: 0
        }
    },
    main              = new Emitter(),
    ADVERTISING_DELAY = 15;


/**
 * Hide osd such as: osd-tv.
 */
function hideSideOsd () {
    var osdToHide = ['magcore-osd-tv'];

    core.taskManager.osdStack.forEach(function ( osd ) {
        if ( osdToHide.indexOf(osd.config.packageName) > -1 ) {
            osd.core.call('hide');
        }
    });
}

function playAds ( target, callback ) {
    spinner.show();
    hideSideOsd();
    if ( core.applicationState && !core.applicationState.visible ) {
        core.call('show');
        core.call('focus');
    }

    setTitle(target.current + 1, target.stack.length);
    if ( app.activePage !== app.pages.advertising ) {
        app.route(app.pages.advertising);
    }

    if ( target.stack[target.current].requiredPart ) {
        target.stack[target.current].onRequiredWatch = function () {
            // show skip button
            main.emit('button:show', {target: target, done: callback});
        };
    }

    player.play(target.stack[target.current], function () {
        // hide skip button
        target.current++;
        if ( target.current >= target.stack.length ) {
            // targets[target]
            target.stack = [];
            target.current = 0;
            target.lastWatch = new Date();
            // skipButton.hide();
            main.emit('button:hide');
            callback();
        } else {
            playAds(target, callback);
        }
    });
}

/**
 * Check incoming intent to get advertising.
 *
 * @param {Intent} intent - intent to check
 * @param {Function} done - done callback after check
 */
main.checkIntent = function ( intent, done ) {
    var previousState = {
            activePage: app.activePage,
            visible: core.applicationState.visible
        },
        target;

    function callback () {
        if ( app.activePage !== previousState.activePage ) {
            console.log(':ads: go back to previous page');
            app.route(previousState.activePage);

            if ( !previousState.visible ) {
                // intent was silent or with context and player was in background mode, so we need to show previous app
                intent.show(intent.creator);
            }
        }
        done();
    }

    console.log(intent, 'advertising check');

    if ( intent.runnerConfig.resource && intent.runnerConfig.resource in targets ) {
        target = targets[intent.runnerConfig.resource];

        console.log(target, 'advertising target');

        // skip advertising for some times at start
        if ( target.skipPlaybackTimes < 4 ) {
            target.skipPlaybackTimes++;
            callback();

            return;
        }
    } else {
        callback();

        return;
    }

    // if we have some not finished ads try to continue watching
    if ( target.stack.length ) {
        playAds(target, function () {
            // callback on end
            callback();
        });

        return;
    }

    // check watch ads delay
    if (  target.lastWatch && (new Date() - target.lastWatch < ADVERTISING_DELAY * 60 * 1000 ) ) {
        // no need to watch ads
        callback();

        return;
    }

    api.getAd(target.startCode, function ( error, data ) {
        if ( error || !data.length ) {
            target.lastWatch = new Date();
            callback();
        } else {

            // here we will show ads
            target.current = 0;
            target.stack = data;
            playAds(target, function () {
                callback();
            });
        }
    });
};

main.addListener('skip', function ( event ) {
    var target   = event.target,
        callback = event.done;

    player.stop();
    target.current++;
    if ( target.current >= target.stack.length ) {
        // targets[target]
        target.stack = [];
        target.current = 0;
        target.lastWatch = new Date();
        // skipButton.hide();
        main.emit('button:hide');
        callback();
    } else {
        playAds(target, callback);
    }
});

function appStartHook ( event ) {
    var target;

    if ( event.app.resource && event.app.resource in targets ) {
        target = targets[event.app.resource];

        if ( target.skipAppStartTimes < 1 ) {
            target.skipAppStartTimes++;
            event.done();

            return;
        }

        // if we have some not finished ads try to continue watching
        if ( target.stack.length ) {
            core.call('show');
            core.call('focus');
            playAds(target, function () {
                core.call('blur');
                core.call('hide');
                event.done();
            });

            return;
        }

        // check watch ads delay
        if ( target.lastWatch && (new Date() - target.lastWatch < ADVERTISING_DELAY * 60 * 1000 ) ) {
            core.call('blur');
            core.call('hide');
            event.done();

            return;
        }

        // this is one of our ads target, lets try to show ads
        api.getAd(api.CODE_APP_START, function ( error, data ) {
            if ( error || !data.length ) {
                event.done();
            } else {
                core.call('show');
                core.call('focus');
                target.current = 0;
                target.stack = data;
                playAds(target, function () {
                    core.call('blur');
                    core.call('hide');
                    event.done();
                });
            }
        });
    } else {
        event.done();
    }
}

window.system.addListener('run:app', appStartHook);


module.exports = main;
